import { useMutation, useQueryClient } from '@tanstack/react-query';
import supabaseClient from '@/api/supabaseClient.ts';

export type AdminOverrideRequest = {
  decision_id: string;
  approval_state_id: string;
  disposition: 'approved' | 'returned';
  override_note: string;
};

async function submitOverride(body: AdminOverrideRequest): Promise<void> {
  const { error } = await supabaseClient.functions.invoke('admin-override', { body });
  if (error) throw new Error(error.message ?? 'Override failed');
}

const useAdminOverride = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: submitOverride,
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({ queryKey: ['admin-sessions'] });
      void queryClient.invalidateQueries({ queryKey: ['admin-session-detail', variables.decision_id] });
    },
  });
};

export default useAdminOverride;
